<template>
    <div>
        <editor v-model="editorContent" @change="sendToPage" :api-key="text_editor_token" :init="{
            selector: 'textarea#open-source-plugins',
            menubar: 'file edit view insert format tools table help',
            plugins: 'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons accordion',
            toolbar: 'undo redo | accordion accordionremove | blocks fontfamily fontsize | bold italic underline strikethrough | align numlist bullist | link image | table media | lineheight outdent indent| forecolor backcolor removeformat | charmap emoticons | code fullscreen preview | save print | pagebreak anchor codesample | ltr rtl',
            font_formats: 'Nikosh=Nikosh,serif; Kalpurush=Kalpurush; SolaimanLipi=SolaimanLipi; Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats;',
            template_cdate_format: '[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]',
            template_mdate_format: '[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]',
            height: 300,
            image_caption: true,
            quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
            noneditable_class: 'mceNonEditable',
            toolbar_mode: 'sliding',
            contextmenu: 'link image table',
            // skin: useDarkMode ? 'oxide-dark' : 'oxide',
            skin: 'oxide',
            content_css: 'default',
            content_style: `
                              @font-face {
                              font-family: 'Nikosh';
                              src: url('@/assets/fonts/Nikosh.ttf') format('truetype');
                              font-weight: normal;
                              font-style: normal;
                            }
                            body { font-family:Helvetica,Arial,sans-serif; font-size:16px }
                            .nikosh { font-family: 'Nikosh', serif; }
                            @font-face {
                              font-family: 'Kalpurush';
                              src: url('@/assets/fonts/kalpurush.ttf') format('truetype');
                              font-weight: normal;
                              font-style: normal;
                            }
                            @font-face {
                              font-family: 'SolaimanLipi';
                              src: url('@/assets/fonts/SolaimanLipi.ttf') format('truetype');
                              font-weight: normal;
                              font-style: normal;
                            }
                            `,
        }" />
    </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'

export default {
    name: 'App',
    components: {
        'editor': Editor
    },
    props: ['htmlFetch', 'index'],
    watch: {
        htmlFetch(htmlData) {
            if (htmlData) {
                this.editorContent = htmlData;
            }
        }
    },
    beforeMount() {
        this.text_editor_token = localStorage.getItem('text_editor_token');
        this.editorContent = this.htmlFetch;
        // console.log('text editor token', this.text_editor_token);
    },
    data() {
        return {
            editorContent: '',
            text_editor_token: '',
        }
    },
    methods: {
        sendToPage() {
            const editorDataWithIndex = {
                index: this.index,
                htmlData: this.editorContent,
            };
            this.$emit('htmlData', this.editorContent);
            this.$emit('htmlDataWithIndex', editorDataWithIndex);
        },
    },
}
</script>
